import { render, staticRenderFns } from "./CelularABM.vue?vue&type=template&id=a218ba74&"
import script from "./CelularABM.vue?vue&type=script&lang=js&"
export * from "./CelularABM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports